import styled from "styled-components";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';

const WidgetContainer = styled.div`
  border: 1px solid ${(props) => props.theme.colors.clearGray};
  border-radius: 8px;
  padding: ${(props) => props.padding || "16px"};
  height: auto;
  min-height: ${(props) => props.height || "auto"};
  max-height: ${(props) => props.maxheight || props.height};
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: ${(props) => props.maxwidth || "100%"};
  position: relative;
  overflow: visible;
  font-family: ${(props) => props.theme.fonts.family.inter};
`;

const GarageWidgetContainer = styled.div`
    & div > div:nth-child(2) {
      position: relative;
      display: flex;
      justify-content: center;
    }
`

const WidgetTitle = styled.h2`
  height: 25px;
  font-weight: bold;
  margin: 0;
  font-size: 14px;
`;

const WidgetContent = styled.div`
  position: relative;
  overflow-y: auto;
  scrollbar-width: thin;
  height: 100%;
  padding-bottom: 24px;
`;

const WidgetHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid ${(props) => props.theme.colors.brightgray};
`;

const WidgetDetails = styled.div`
  font-size: 14px;
  color: ${(props) => props.theme.colors.activeBlue};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const DataAvaliableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  padding: 20px;
  color: ${(props) => props.theme.colors.darkGray};
`;

const InfoList = styled.ul`
  list-style: none;
  padding: ${(props) => props.isGarageCard ? '0 35px' : '0'};
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2.5px;

  & li {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    gap: 5px;
    align-items: center;
  }
`;

const InfoWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const EditContainer = styled.div`
  cursor: ${(props) => props.isLoading ? "progress" : "pointer"};
`;

const SubTitle = styled.div`
  font-weight: bold;
  font-size: 0.875rem;
`;

const EditWrapper = styled.div`
  cursor: pointer;
`;

const CarouselContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 5px;
`;

const CarouselButtons = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CarouselButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const OrdersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 320px;

  & > ul {
    list-style: none;
    padding: 12px 0;
    margin: 0;
    border-bottom: 1px solid ${(props) => props.theme.colors.clearGray};
  }

  & > ul:last-child {
    border: none;
  }

  & li {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    gap: 5px;
    align-items: center;
  }
`;

const ROStatusField = styled.span`
  height: 16px;
  font-size: 0.625rem;
  padding: 2px 8px;
  background: ${(props) =>
    props.status === "inprogress"
      ? props.theme.colors.greyEight
      : props.status === "standby"
        ? props.theme.colors.jordyBlue
        : props.status === "completed"
          ? props.theme.colors.greenTea
          : props.theme.colors.greyEight};
  border-radius: 100px;
  text-transform: capitalize !important;
`;

const AppointmentsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > ul {
    list-style: none;
    padding: 12px 0;
    margin: 0;
    border-bottom: 1px solid ${(props) => props.theme.colors.clearGray};
  }

  & > ul:last-child {
    border: none;
  }

  & li {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    gap: 5px;
    align-items: flex-start;
  }
`;

const ShortDescription = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const NotificationWrapper = styled.div`
  padding: 16px;
  background: ${(props) => props.theme.colors.white};
  min-height: 140px;
  height: auto;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition:
    background-color 0.3s ease,
    border 0.3s ease;
  border: ${(props) => `1px solid ${props.theme.colors.clearGray}`};
`;

const NotificartionTitle = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
`;

const NotificartionDescription = styled.span`
  font-size: 0.75rem;
  font-weight: normal;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

const NotificationTypeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  font-size: 12px;

  & > span:first-child {
    text-transform: capitalize;
  }
  
  & > span:last-child{
    color: ${(props) => props.theme.colors.silverSand};
  }
`;

const NotificationActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 0.625rem;
  padding: 13px 0 0 0;
  border-top: 1px solid ${(props) => props.theme.colors.silverSand};
`;

const NotificationsActionsViewDetails = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 8px;
  cursor: pointer;

  & > span:first-child {
    color: ${(props) => props.theme.colors.activeBlue};
  }
`;

const NotificationMarkCompleted = styled.div`
  display: flex;
  border-radius: 8px;
  border: ${(props) => props.isCompleted ?  `1px solid ${props.theme.colors.silverSand}` : `1px solid ${props.theme.colors.black}`};
  padding: 8px;
  cursor: pointer;
  background: ${(props) => props.isCompleted ? props.theme.colors.white : props.theme.colors.black};
  color: ${(props) =>
    props.isCompleted
      ? props.theme.colors.black
      : props.theme.colors.white};
  font-weight: 600;
  transition:
    background-color 0.3s ease,
    border 0.3s ease;
  font-size: 0.875rem;
`;

const NotificationDetails = styled.span`
  cursor: pointer;
  font-size: 0.875rem;
`;

const NotificationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Loading = styled.div`
  padding: 10px;
  text-align: center;
`;

/*Garage Card Carousel Styles*/

const NestedSlider = styled.div`
  height: 200px;
  display: flex;
  gap: 10px;
`;

const Panel = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.darkCharcoal};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 1.2rem;
`;

const PanelLarge = styled(Panel)`
  width: 300px;
  height: 200px;
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const VehicleImage = styled.img`
  max-width: 100%;
  object-fit: contain;
`;


const NotesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 0.5rem;

  & > div:last-child {
    padding-bottom: 0;
  }
`;

const NotesDataContainer = styled.div`
   border-bottom: 1px solid ${(props) => props.theme.colors.highClearGray};
   display: flex;
   flex-direction: column;
   gap: 12px;
   padding-bottom: 12px;
   cursor: ${(props) => props.isOwner && !props.disabled ? 'pointer' : 'none'};
`;

const NoteHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;

  & > span {
    font-size: 14px;
    font-weight: 600;
  }

  & > div:nth-child(2), & > div:nth-child(3) {
    background: ${(props) => props.theme.colors.highClearGray};
    border-radius: 8px;
    font-size: 10px;
    font-weight: 700;
    padding: 4px 8px;
  }
`;


const NotesDescription = styled.div`
    font-size: 14px;
    font-weight: 400;

    p {
      overflow: hidden;
      display: -webkit-box;
      display: -moz-box;
      display: box;
      -webkit-line-clamp: 2;
      -moz-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      -moz-box-orient: vertical;
      box-orient: vertical;
      margin: 0;
      text-overflow: ellipsis;
     }

    & > span {
      font-size: 10px;
      font-weight: 300;
    }
`

const MiningAlert = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid ${(props) => props.theme.colors.highClearGray};
    padding: 10px 0;
    
    & > div:first-child {
      display: flex;
      flex-direction:column;
      align-items: flex-start;
      gap: 8px;
    }
    
    & > div > span {
      font-weight: 400;
      font-size: 12px;
    }
`;

const NotificationStatusWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const NotificationsStatus = styled.div`
  border-radius: 50px;
  width: auto;
  padding: 3px 12px;
  background: ${(props) =>
    props.status === "pending"
      ? props.theme.colors.dairyCream
      : props.status === "completed"
        ? props.theme.colors.whiteIce
        : props.theme.colors.white};
  border: ${(props) => props.status === "pending" ? `1px solid ${props.theme.colors.sandyBeach}` : props.status === "completed" ? `1px solid ${props.theme.colors.greenCyan}` : `1px solid ${props.theme.colors.black}`};
  text-transform: capitalize;
  font-weight: 600;
  color: ${(props) => props.status === "pending" ? props.theme.colors.brownRust : props.status === "completed" ? props.theme.colors.darkSpringGreen : props.theme.colors.black};
`;

const NotificationAssignedWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px;
  color: ${props => props.theme.colors.greyCloud};
  font-size: 14px;
  align-items: center;
  flex-wrap: wrap;
`;

const NotificationAssigned = styled.div`
  max-width: 102px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledPersonIcon = styled(PersonOutlineOutlinedIcon)`
  width: 24px;
  height: auto;
  color: ${props => props.theme.colors.silverSand};
`;

const AssignToMeButton = styled.div`
  display: flex;
  border-radius: 8px;
  border: 1px solid ${props => props.theme.colors.silverSand};
  padding: 8px;
  cursor: pointer;
  background: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.black};
  font-weight: 600;
  transition: all 0.3s ease;
  font-size: 0.875rem;
`;

const NotificationButtons = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 10px;
`;
export {
  EditContainer,
  WidgetContainer,
  WidgetTitle,
  WidgetContent,
  WidgetHeader,
  WidgetDetails,
  DataAvaliableWrapper,
  SubTitle,
  InfoWrapper,
  InfoList,
  EditWrapper,
  CarouselContainer,
  CarouselButtons,
  CarouselButton,
  OrdersWrapper,
  ROStatusField,
  AppointmentsWrapper,
  ShortDescription,
  NotificationWrapper,
  NotificartionTitle,
  NotificartionDescription,
  NotificationTypeWrapper,
  NotificationActions,
  NotificationsActionsViewDetails,
  NotificationMarkCompleted,
  NotificationDetails,
  NotificationContainer,
  Loading,
  NestedSlider,
  Panel,
  PanelLarge,
  ImageContainer,
  VehicleImage,
  GarageWidgetContainer,
  NotesWrapper,
  NotesDataContainer,
  NoteHeader,
  NotesDescription,
  MiningAlert,
  NotificationStatusWrapper,
  NotificationsStatus,
  NotificationAssignedWrapper,
  NotificationAssigned,
  StyledPersonIcon,
  AssignToMeButton,
  NotificationButtons
};
